import { createAction } from '@reduxjs/toolkit';

import { PlansToUpgrade } from '../types';

const nameStore = '@webapp/subscription/upgradeCall';

export const openUpgradeModal = createAction<PlansToUpgrade>(
  `${nameStore}/openUpgradeModal`,
);
